import React, { type ComponentProps } from 'react';
import type { ViewProps } from 'react-native';
import { StyleSheet, View } from 'react-native';
import { Button, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const ScanInStoreCta = (props: ScanInStoreCtaProps) => {
  const {
    containerStyle,
    onPress,
    children,
    palette = 'secondary',
    isLoading = false,
  } = props;

  const containerStyles = [styles.container, containerStyle];

  return (
    <View style={containerStyles}>
      <Button
        size="small"
        palette={palette}
        style={styles.cta}
        onPress={onPress}
        isLoading={isLoading}
      >
        {children}
      </Button>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
  },
  cta: {
    paddingHorizontal: theme.spacing['4'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type ScanInStoreCtaProps = Readonly<{
  children: ComponentProps<typeof Button>['children'];
  onPress: () => void;
  containerStyle?: ViewProps['style'];
  palette?: 'white' | 'secondary';
  isLoading?: boolean;
}>;
